import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { Backdrop } from '@mui/material'

import useStyle from 'shared/hooks/useStyle'
import Loading from 'shared/Loading'
import ROUTE_KEYS from 'shared/utils/routeKeys'

import InputContextProvider from './InputContextProvider'

import useProcess from './hooks'
import ProcessActions from './ProcessActions'
import ProcessBar from './ProcessBar'
import ProcessGroup from './ProcessGroup'
import ProcessSummary from './ProcessSummary'
import styles from './ProcessPage.style'

const propTypes = {
    processKey: PropTypes.string.isRequired,
    assetNumber: PropTypes.string.isRequired,
    directScan: PropTypes.bool,
}

const ProcessPage = ({
    assetNumber,
    processKey,
    directScan = false,
}) => {
    const classes = useStyle(styles)
    const navigate = useNavigate()
    const cancelCallback = useCallback(() => {
        navigate(ROUTE_KEYS.MAIN)
    }, [navigate])
    const {
        isLoading = false,
        error,
        showSummary,
        groups,
        currentGroup,
        userInput,
        onUserInputChange,
        onUserInputClear,
        onAction,
        changedBy,
    } = useProcess({
        processKey,
        assetNumber,
        directScan,
        cancelCallback,
    })

    // console.log('ProcessPage isLoading:', isLoading)

    if (error) {
        throw error
    }

    return (
        <div css={classes.root}>
            <Backdrop
                css={classes.backdrop}
                open={isLoading}
            >
                <Loading />
            </Backdrop>
            {!showSummary
            && (
                <InputContextProvider callback={onUserInputClear}>
                    <>
                        <ProcessBar
                            groups={groups}
                            current={currentGroup}
                        />
                        <div css={classes.main}>
                            {currentGroup && (
                                <div css={classes.content}>
                                    <ProcessGroup
                                        css={classes.page}
                                        steps={currentGroup.steps}
                                        assetNumber={assetNumber}
                                        inputCallback={onUserInputChange}
                                        changedBy={changedBy}
                                    />
                                    <ProcessActions
                                        userInput={userInput}
                                        currentGroup={currentGroup}
                                        actionCallback={onAction}
                                    />
                                </div>
                            )}
                        </div>
                    </>
                </InputContextProvider>
            )}
            {showSummary && (
                <ProcessSummary
                    assetNumber={assetNumber}
                    actionCallback={onAction}
                    changedBy={changedBy}
                />
            )}
        </div>
    )
}

ProcessPage.propTypes = propTypes

export default ProcessPage
